import React from 'react';
import {Link} from 'react-router-dom';

export const NotifyButton = ({ booleanValidation, pathName, className = '', style }) => {
  const finalClass = `btn btn-success py-2 w-100 rounded-3 ${className}`;
  return booleanValidation ?
    <button disabled={booleanValidation} type='button' className={finalClass} style={style} >
      <span className="mdi mdi-email me-2"></span>Notificar
    </button>
    : <Link
      to={{
        pathname: pathName,
      }}
      style={{ display: 'inline-block', width: style?.width }}
    >
      <button disabled={booleanValidation} type='button' className={finalClass} style={style} >
        <span className="mdi mdi-email me-2"></span>Notificar
      </button>
    </Link>;
}
